import { Schema } from '@core/data/dto/schema';

export const DeliveryOrderCourierSchema = {
    id: Schema.String,
    name: Schema.String,
    rating: Schema.Number,
    vehicle_type: Schema.String,
    phone_number: Schema.String,
    img_href: Schema.String,
    polyline: Schema.String,
    avatar_url: Schema.String,
    location: Schema.Auto
};
